/**
 * @file Number input type - extends String with number input type and parsing
 * @version 1.0.0
 */

import { StringInputType } from './string.js';

export const NumberInputType = {
  name: 'number',
  matches: getAttribute =>
    getAttribute('type') === 'number' || getAttribute('type') === 'integer',
  displayComponent: StringInputType.displayComponent,
  editComponent: {
    name: 'NumberEdit',
    extends: StringInputType.editComponent,
    methods: {
      getInputType() {
        return 'number';
      },
      getInputAttributes() {
        return {
          placeholder: this.getAttribute('description'),
          min: this.getAttribute('minimum'),
          max: this.getAttribute('maximum'),
          step: this.getAttribute('type') === 'integer' ? '1' : 'any',
        };
      },
      parseInputValue(event) {
        const inputValue = event.target.value;
        if (inputValue === '') return undefined;

        const numValue = parseFloat(inputValue);
        if (isNaN(numValue)) return inputValue; // Return invalid input to trigger validation error

        return numValue;
      },
    },
  },
};

export default NumberInputType;
